<template>
  <div class="trade_layer" v-show="isShow">
    <div class="hd">
      <h3 class="tit">{{ tradeType === 'SELL' ? '구매하기' : '판매하기' }}</h3>
      <a class="btn_close" href="javascript:;" v-on:click="closePopup"></a>
    </div>
    <div class="bd">
      <div class="item">
        <div class="name">{{ item.name }}</div>
        <img class="img" :src="item.imageUrl" :alt="item.name" />
        <div class="tip">{{ item.description }}</div>
        <dl class="detail">
          <dt>거래방식</dt>
          <dd>{{ tradeType === 'SELL' ? '구매하기' : '판매하기' }}</dd>
          <dt>거래상태</dt>
          <dd>{{ statusText }}</dd>
          <dt>판매골드</dt>
          <dd><span class="gold">{{ numberToString(item.amount) }}</span></dd>
          <dt>등록자</dt>
          <dd>
            <img class="lv" :src="'/refer/img/level/lv'+item.level+'.png'" :alt="item.nickname" :title="item.nickname" />
            <span class="nick">{{ item.nickname }}</span>
          </dd>
        </dl>
      </div>

      <p class="noti" v-show="!hasItem && item.isMine === false">{{ hasItemText }}</p>
      <div class="btn_area" v-show="!hasItem && item.isMine === false">
        <button class="btn btn_cancel w100" v-on:click="closePopup">창 닫기</button>
      </div>

      <div class="btn_area" v-show="hasItem && item.isMine === false">
        <button class="btn btn_exec" v-if="item.status === 1" v-on:click="tradeItem">{{ tradeType === 'SELL' ? '구매하기' : '판매하기' }}</button>
        <button class="btn btn_cancel" v-on:click="closePopup">창 닫기</button>
      </div>

      <div class="btn_area" v-show="item.isMine === true">
        <button class="btn btn_exec" v-if="item.status === 1" v-on:click="cancelItem">등록취소</button>
        <button class="btn btn_cancel" v-on:click="closePopup">창 닫기</button>
      </div>
    </div>
  </div>

</template>

<script>
  import common from '../../mixins/common';

  export default {
    name: "trade-popup",
    mixins: [
      common
    ],
    data() {
      return {
        isShow: false,
        item: [],
        hasItem: false
      }
    },
    created() {
      this.$eventBus.$on("openTradePopop", this.openTradePopop);
    },
    methods: {
      openTradePopop(item) {
        this.item = item;
        this.isShow = true;
        this.getMyItem();

        $("._layer_background").click( () => {
          $('._layer_background').hide();
          this.closePopup();
        })
      },
      async getMyItem() {
        let res = await this._get("/v1/trade/hasMyItem", {
          tradeId: this.item.id,
          tradeType: this.tradeType
        })

        this.hasItem = res.data.hasItem;
      },
      async tradeItem() {
        let res = await this._post("/v1/trade/item", {
          tradeId: this.item.id,
          tradeType: this.tradeType
        });

        this.isShow = false;
        this.item.status = 2;
        this.$eventBus.$emit("changeLIstItem");
        alert(res.data.message);
        $('._layer_background').hide();
      },
      async cancelItem() {

        if (confirm('등록을 취소하시겠습니까?') === false) {
          return false;
        }

        let res = await this._delete("/v1/trade/" + this.item.id, {
          tradeType: this.tradeType
        });

        this.isShow = false;
        this.item.status = 2;
        this.$eventBus.$emit("changeLIstItem");
        alert(res.data.message);
        $('._layer_background').hide();
      }
    },
    computed: {
      statusText() {
        return this.item.status === 1 ? '거래대기' : '거래완료';
      },
      hasItemText() {
        return this.$route.query.tradeType === 'BUY' ? '판매 가능한 아이템이 없습니다' : '보유 골드가 부족합니다.';
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/store/trade-popup.vue